<template>
  <div>
  <span
    class="special-header font_size_1000rem py-2"
  >
    {{ currentSectionTitle }}
  </span>
  <span class="proxy" v-if="!!question.is_proxy_enabled">Proxy Question</span>
  </div>
</template>

<script>
import { QUESTION_TYPES } from '@/store';

export default {
  name: 'SectionProgressBar',
  props: {
    question: Object,
    sections: Array,
  },
  computed: {
    currentSection: function () {
      if (this.question.type === QUESTION_TYPES.GEOGRAPHY_ICO_WRAPPER) {
        return null;
      }
      return this.sections.find((section) => {
        return (
          Array.isArray(section.questionSections) &&
          section.questionSections.some(
            (qs) => qs.question_id === this.question.id
          )
        );
      });
    },

    currentSectionTitle: function () {
      if (this.question.type === QUESTION_TYPES.GEOGRAPHY_ICO_WRAPPER) {
        return 'Geography preference';
      }
      return (this.currentSection || {}).title || '';
    },
  },
};
</script>

<style scoped>
.proxy {
  border: 2px solid #FEAA02;
  background-color: #FEAA02;
  color: white;
  padding: 5px;
}
</style>
